import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.074 18.048l.008.009c-.198 1.37-.226 2.837-.084 4.398a.5.5 0 0 1-.996.09c-.18-1.982-.098-3.825.246-5.528C2.379 15.528 2 13.581 2 11.345c0-3.746 2.127-7.079 6.342-9.11 1.24-.597 2.65-.962 4.197-1.128 2.125-.228 4.366-.077 6.548.311.88.157 1.552.315 1.87.407 1.77.393 2.288 2.232.91 3.515-.116.095-.342.298-.64.596a15.464 15.464 0 0 0-1.489 1.722c-1.152 1.555-1.897 3.188-2.06 4.817-.503 5.043-3.453 7.658-8.244 7.658-1.87 0-3.336-.432-4.453-1.212.481-5.321 3.385-9.295 8.743-11.974a.5.5 0 0 0-.448-.894C7.87 8.756 4.793 12.77 4.074 18.048zm0 0l-.458-.468z"
});

var SvgOrganicFilled = function SvgOrganicFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgOrganicFilled;